import { CompanyTableInfo } from '../feature/search-table-company';
import { PeopleTableInfo } from '../feature/search-table-people';

export type SearchBrowseParams = {
  value?: string;
  type?: SearchMode.Similarity | SearchMode.Semantic;
} & SearchQueryFilters;

export type SearchQueryFilters = {
  [key: string]: string;
};

export enum SearchMode {
  Similarity = 'Similarity',
  Semantic = 'Semantic',
}

export enum SearchType {
  Company = 'Company',
  People = 'People',
}

export enum SearchTable {
  Company = 'Company',
  People = 'People',
  Employees = 'Employees',
  BuyingTeam = 'BuyingTeam',
}

export type SearchItemUnionProps = PeopleTableInfo & CompanyTableInfo;

export enum SearchMatchType {
  SMART = 'SMART',
  WORD = 'WORD',
  STRICT = 'STRICT',
}
